import React from 'react';
import useGetStartedActionsContext from 'contexts/get-started-actions.context';
import AddTeamForm from './add-team-form';
import { FileDetailsType } from './add-csv-file';
import { DepartmentType } from 'models/department.model';

export const defaultData = {
  first_name: '',
  last_name: '',
  phone_number: '',
  email: '',
  birthday: '',
  department: '',
  budget: '',
  budget_duration: '',
  budget_setting: '',
  role: '',
  department_name: ''
};

type Props = {
  departmentOptions: DepartmentType[];
};

const AddTeamManually = ({ departmentOptions }: Props) => {
  const { teamDataForm, setTeamDataForm } = useGetStartedActionsContext();
  const updateMemberData = (index: number, newTeam: FileDetailsType) =>
    setTeamDataForm(
      teamDataForm.map((team, i) => {
        if (i === index) return newTeam;
        return team;
      })
    );
  const getDepartment = (departmentName: string | undefined) => {
    const dptObject = departmentOptions.find((dpt: DepartmentType) => {
      return dpt.name === departmentName;
    });

    return dptObject;
  };
  return (
    <div>
      <div>
        {teamDataForm.map((item, index) => (
          <AddTeamForm
            key={index}
            index={index}
            teamData={item}
            setTeamData={(newTeam) => updateMemberData(index, newTeam)}
            showRemoveButton={index !== 0}
            departmentOptions={departmentOptions}
            department={getDepartment(item.department)}
          />
        ))}
      </div>
    </div>
  );
};

export default AddTeamManually;
